<template>
    <div class="loader" v-if="showLoader">
        <div class="loader-bg" :class="exitLoader?'loader-bg-end':''"></div>
        <div class="ball" v-if="!exitLoader"></div>
        <div class="ball" v-if="!exitLoader"></div>
    </div>
</template>

<script>
export default {
    props: {
        exitLoader: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            showLoader: true
        }
    },
    watch:{
        exitLoader(n){
            if( n ){
                setTimeout(() => {
                    this.showLoader = false
                },300)
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.loader
    position fixed
    top 0
    bottom 0
    left 0
    right 0
    z-index 50
    display flex
    align-items center
    justify-content center
    .loader-bg
        position absolute
        width 200vw
        height 200vw
        background #1D1D1D
        transform scale(1.5)
        border-radius: 50%
        transition all .3s
    .loader-bg-end
        width 0
        height 0
    .ball
        position absolute
        display inline-block
        width 20px
        height 20px
        border-radius 50%
        &:nth-child(2)
            background linear-gradient(-45deg,rgba(213,161,77,1),rgba(255,214,149,1));
            transform: translateX(-20px);
            animation: moveRight 0.5s linear infinite alternate;
        &:nth-child(3)
            background #ffffff
            transform: translateX(20px);
            animation: moveLeft 0.5s linear infinite alternate;

@-webkit-keyframes moveRight {
	to { -webkit-transform: translateX(20px); }
}
@keyframes moveRight {
	to { transform: translateX(20px); }
}
@-webkit-keyframes moveLeft {
	to { -webkit-transform: translateX(-20px); }
}
@keyframes moveLeft {
	to { transform: translateX(-20px); }
}
</style>